import script from "./nav-bar-status-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./nav-bar-status-bar.vue?vue&type=script&setup=true&lang=ts"

import "./nav-bar-status-bar.vue?vue&type=style&index=0&id=53d29138&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53d29138"]])

export default __exports__